import React, { useEffect, useState } from "react";
import { IconButton, Button, Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

import Skeleton from "@mui/material/Skeleton";
import dayjs from "dayjs";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import { BrowserView, MobileView } from "react-device-detect";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { Menu, MenuItem as ReactMenuItem } from "@szhsin/react-menu";

import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { ReactComponent as SendIcon } from "../../icons/Send24.svg";
import { ReactComponent as EditIcon } from "../../icons/Edit24.svg";
import { ReactComponent as MoreHorizIcon } from "../../icons/MoreHoriz24.svg";

import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";

import SelectStudentsDialog from "../../components/faculty/SelectStudentsDialog";
import SelectStudentListsDialog from "../../components/faculty/SelectStudentListsDialog";
import AttendeeDetailsDialog from "../../components/faculty/AttendeeDetailsDialog";
import AddStudentResultDialog from "../../components/faculty/AddStudentResultDialog";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import TableRowNoResults from "../../components/TableRowNoResults";

import clone from "lodash-es/clone";
import isEmpty from "lodash-es/isEmpty";

import {
  showError,
  showToast,
  showOKCancelDialog,
} from "../../components/ATPDialogs";
import {
  teacherAddCommService,
  getActivityDateCommServices,
  deleteCommService,
} from "../../services/CommServiceService";
import { getUserPriority, getUserSettings } from "../../services/UserService";

import { doService } from "../../services/ServiceHelper";
import {
  addStudentsToActivityDate,
  validateStudentsToActivityDate,
  getActivityDateStudents,
  addStudentListToActivityDate,
  createADUserList,
  updateSADTeacherComment,
  updateAttendance,
  getFutureActivityDates,
  sendActivityDateMessage,
  bulkAdd,
} from "../../services/ActivityService";
import {
  getTeacherUserLists,
  getSchoolStudents,
} from "../../services/UserService";
import { getScoreCategories, saveADPoints } from "../../services/ScoreService";

import { hasError, getError } from "../../services/ServiceHelper";
import "../../ResponsiveTable.css";
import ActivityDetails from "../../components/faculty/ActivityDetails";

import {
  StripedTableRow,
  StripedTableCell,
} from "../../components/StripedTable";

import CommServiceBulkDialog from "../../components/admin/CommServiceBulkDialog";
import { getPeriodName } from "../../services/SchoolService";
import TextField from "@mui/material/TextField";
import SearchBar from "../../components/faculty/SearchBar";
import { getSchoolStatus } from "../../services/SchoolService";
import StudentActivitySignupDialog from "../../components/StudentActivitySignupDialog";

import { getDayJsMD, getDayJsDay } from "../../services/DateService";

const TakeAttendance = () => {
  const navigate = useNavigate();

  const [_school] = useLocalStorage("Auth", "school", null);
  const { activityDateEid } = useParams();

  const [_jwt] = useJwtStorage();
  const [_activityDetails, setActivityDetails] = useState({});
  const [_activityStudents, setActivityStudents] = useState([]);
  const [_userListOptions, setUserListOptions] = useState([]);
  const [_userListsMap, setUserListsMap] = useState({});
  const [_students, setStudents] = useState([]);
  const [_scoreCategories, setScoreCategories] = useState([]);

  const [_dialogStudentsOpen, setDialogStudentsOpen] = React.useState(false);
  const [_dialogStudentListsOpen, setDialogStudentListsOpen] =
    React.useState(false);
  const [_dialogPointsOpen, setDialogPointsOpen] = React.useState(false);
  const [_dialogDetailsOpen, setDialogDetailsOpen] = React.useState(false);
  const [_dialogSelectActivityOpen, setDialogSelectActivityOpen] =
    React.useState(false);
  const [_dialogStudentResultOpen, setDialogStudenResultOpen] =
    React.useState(false);

  const [_showProgress, setShowProgress] = useState(false);

  const [_presentCount, setPresentCount] = useState(0);
  const [_lateCount, setLateCount] = useState(0);
  const [_absentCount, setAbsentCount] = useState(0);

  const [_selectedStudent, setSelectedStudent] = useState({});
  const [_selectedScoreCategory, setSelectedScoreCategory] = useState("0");
  const [_selectedScoreValue, setSelectedScoreValue] = useState("0");
  const [_selectedAttendee, setSelectedAttendee] = useState({});

  // captures students that need to be updated
  const [_mapQueue, setMapQueue] = useState({});

  const [_selectedTabIndex, setSelectedTabIndex] = React.useState(0);

  const [_addSuccesses, setAddSuccesses] = useState([]);
  const [_addFails, setAddFails] = useState([]);
  const [_deltaAttendanceCount, setDeltaAttendanceCount] = useState(0);
  const [_commServiceDialogOpen, setCommServiceDialogOpen] = useState(false);
  const [_dialogFutureDatesOpen, setDialogFutureDatesOpen] = useState(false);
  const [_commServiceType, setCommServiceType] = useState("XX");
  const [_commServiceDescription, setCommServiceDescription] = useState("");
  const [_existingOps, setExistingOps] = useState([]);
  const [_isLoaded, setIsLoaded] = useState(false);
  const [_futureActivityDates, setFutureActivityDates] = useState([]);
  const [_lateToTardy, setLateToTardy] = useState(false);
  const [_studentId, setStudentId] = useState("");

  const [_openMessage, setOpenMessage] = useState(false);
  const [_messageText, setMessageText] = useState("");
  const [_schoolStatus, setSchoolStatus] = useState({});
  const [_dialogDate, setDialogDate] = useState("");

  const [_userSettings, setUserSettings] = useState({});

  useEffect(() => {
    initSchoolStatus();
    initUserLists();
    initActivityDateStudents();
    initStudents();
    initScoreCategories();
    initUserSettings();
  }, []);

  const initUserSettings = () => {
    doService(getUserSettings(_school, _jwt), (result) => {
      setUserSettings(result.data);
    });
  };

  const initSchoolStatus = () => {
    doService(getSchoolStatus(_school, _jwt), (results) => {
      setSchoolStatus(results.data);
    });
  };

  const initScoreCategories = () => {
    getScoreCategories(_school, _jwt)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get Score Categories: ", getError(results));
          return;
        }

        setScoreCategories(results.data);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const initActivityDateStudents = () => {
    setShowProgress(true);
    getActivityDateStudents(_school, _jwt, activityDateEid)
      .then((results) => {
        setShowProgress(false);
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to get Activity Date Students: ",
            getError(results),
          );
          return;
        }

        // attach a few extra attributes for each student
        for (let student of results.data.attendees) {
          student.pointChecked = false;
          student.hourNum = 0;
          student.minuteNum = 0;
          student.isFutureChecked = true;
        }

        setActivityStudents(results.data.attendees);
        setActivityDetails(results.data);
        setIsLoaded(true);
        updateCounts(results.data.attendees);
        setDialogDate(results.data.date);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const initStudents = () => {
    getSchoolStudents(_school, _jwt)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get Students: ", getError(results));
          return;
        }

        const labeledStudents = [];
        for (const student of results.data) {
          let label = `${student.last_name}, ${student.first_name}`;

          if (!isEmpty(student.mi)) {
            label += ` ${student.mi}.`;
          }

          label += ` (${student.grade})`;
          labeledStudents.push({
            label: label,
            value: student.eid,
          });
        }

        setStudents(labeledStudents);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const initUserLists = () => {
    getTeacherUserLists(_school, _jwt)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get User Lists: ", getError(results));
          return;
        }

        const labeledLists = [];
        const map = {};
        for (const studentList of results.data) {
          labeledLists.push({
            label: studentList.name,
            value: studentList.id,
          });
          const key = `u${studentList.id}`;
          map[key] = studentList.studentCount;
        }
        setUserListsMap(map);
        setUserListOptions(labeledLists);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const gotoAddStudentList = () => {
    setDialogStudentListsOpen(true);
  };

  const gotoApplyPoints = () => {
    setDialogPointsOpen(true);
  };

  const gotoAddStudent = () => {
    setDialogStudentsOpen(true);
  };

  const gotoCreateList = () => {
    let name = window.prompt("Please enter the new Student List name.");

    if (isEmpty(name)) {
      showError("Unable to Create List", "Please enter Student List name.");
      return;
    }

    setShowProgress(true);
    createADUserList(_school, _jwt, activityDateEid, name)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to create activity date user list: ",
            getError(results),
          );
          return;
        }
        showToast("S", "User List Created");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress();
      });
  };

  const handleChangeListAction = (event) => {
    switch (event.value) {
      case "CS":
        return gotoCreateList();
      case "AS":
        return gotoAddStudent();
      case "ASS":
        return gotoAddStudentList();
      case "AP":
        return gotoApplyPoints();
      case "FD":
        return gotoFutureDates();
      case "CSER":
        return gotoCommunityService();
      case "SM":
        return gotoSendMessage();
      default:
        return null;
    }
  };

  const gotoSendMessage = () => {
    setMessageText("");
    setOpenMessage(true);
  };

  const gotoCommunityService = () => {
    setCommServiceDialogOpen(true);

    setCommServiceDescription("");
    setCommServiceType("XX");

    initExistingOps();
  };

  const handleStudentsClose = () => {
    setDialogStudentsOpen(false);
  };

  const handleStudentListClose = () => {
    setDialogStudentListsOpen(false);
  };

  const handleStudentListOK = (selectedList) => {
    setDialogStudentListsOpen(false);

    const key = `u${selectedList.value}`;
    const currentCount = _activityStudents.length;
    const userListCount = _userListsMap[key] ? _userListsMap[key] : 0;
    const proposedCount = currentCount + userListCount;
    const maxCount = _activityDetails.maxAttendance;

    if (proposedCount > maxCount) {
      if (
        !window.confirm(
          `WARNING: If you add this list of ${userListCount} student(s), you will exceed the activity's max attendance of ${maxCount} student(s).\nClick OK to continue adding students, or cancel to stop.`,
        )
      ) {
        return;
      }
    }

    setShowProgress(true);
    addStudentListToActivityDate(
      _school,
      _jwt,
      activityDateEid,
      selectedList.value,
    )
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to Add Student List: ", getError(results));
          return;
        }

        setAddSuccesses(results.data.successes);
        setAddFails(results.data.fails);
        setDialogStudenResultOpen(true);
        initActivityDateStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const doAddStudentsToActivityDate = (studentEids) => {
    addStudentsToActivityDate(_school, _jwt, activityDateEid, studentEids, true)
      .then((results) => {
        if (hasError(results) === true) {
          showError("Unable to Add Students", getError(results));
          return;
        }

        setAddSuccesses(results.data.successes);
        setAddFails(results.data.fails);
        setDialogStudenResultOpen(true);

        initActivityDateStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleStudentsOK = async (selectedStudents) => {
    setDialogStudentsOpen(false);

    // hack for SSS
    if (_school.eid === "9241fe59-40fe-4ac6-aa89-49eaae988b3d") {
      if (selectedStudents != null) {
        // set current student; show the dialog
        selectedStudents.user_eid=selectedStudents.value;
        setSelectedStudent(selectedStudents);
        setDialogSelectActivityOpen(true);
        return;
      } else {
        return;
      }
    }

    if (selectedStudents.length === 0) {
      return;
    }

    const currentCount = _activityStudents.length;
    const proposedCount = currentCount + selectedStudents.length;
    const maxCount = _activityDetails.maxAttendance;

    if (proposedCount > maxCount) {
      if (
        !window.confirm(
          `WARNING: If you add this set of ${selectedStudents.length} student(s), you will exceed the activity's max attendance of ${maxCount} student(s).\nClick OK to continue adding students, or cancel to stop.`,
        )
      ) {
        return;
      }
    }

    // collect IDs from raw values
    const studentEids = [];
    for (const student of selectedStudents) {
      studentEids.push(student.value);
    }

    const results = await validateStudentsToActivityDate(
      _school,
      _jwt,
      activityDateEid,
      studentEids,
    );
    const messages = results.data.messages;

    if (messages.length === 0) {
      setShowProgress(true);
      doAddStudentsToActivityDate(studentEids);
    } else {
      // we found an issue, show the warning dialog with option to continue
      showOKCancelDialog(
        `The following issues were found.  Click OK to continue adding students, or Cancel to stop.`,
        messages,
        () => {
          setShowProgress(true);
          doAddStudentsToActivityDate(studentEids);
        },
      );
    }
    console.log(results);
  };

  const getComments = (student) => {
    if (isEmpty(student.comment) && isEmpty(student.teacherComment)) {
      return " -- NONE --";
    }
    let comment = "";
    if (!isEmpty(student.comment)) {
      comment = "STUDENT: " + student.comment;
    }
    if (!isEmpty(student.teacherComment)) {
      if (comment !== "") {
        comment += ", ";
      }
      comment += "TEACHER: " + student.teacherComment;
    }
    if (!isEmpty(student.courseName)) {
      if (comment !== "") {
        comment += ", ";
      }
      comment += "COURSE: " + student.courseName;
    }

    return comment;
  };

  const handleClickTeacherComment = (event, student) => {
    const comment = window.prompt("Please enter comment.");
    if (comment == null) {
      return;
    }

    updateSADTeacherComment(
      _school,
      _jwt,
      student.studentActivityDateEid,
      comment,
    )
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to update comment: ", getError(results));
          return;
        }
        showToast("S", "Comment Saved");
        initActivityDateStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const handleClickStudentTransfer = (event, student) => {
    setShowProgress(true);

    setSelectedStudent(student);
    setDialogSelectActivityOpen(true);
  };

  const handleChangeAllPointsModify = (event) => {
    const checked = event.target.checked;
    const activityStudents = clone(_activityStudents);

    for (let student of activityStudents) {
      student.pointChecked = checked;
      evalStudentStatus(student);
    }

    setActivityStudents(activityStudents);
  };

  const handleChangeLateToTardy = (event) => {
    setLateToTardy(event.target.checked);
  };

  const handleChangeAllPresentModify = (event) => {
    const checked = event.target.checked;
    const activityStudents = clone(_activityStudents);
    const mapQueue = clone(_mapQueue);

    for (let student of activityStudents) {
      student.is_present = checked;

      let status = "";

      if (student.is_late) {
        status = "late";
      } else {
        if (student.is_present) {
          status = "present";
        } else {
          status = "absent";
        }
      }

      mapQueue[student.user_eid] = status;

      student.is_present = checked;
      student.is_late = false;
    }

    setMapQueue(mapQueue);
    setActivityStudents(activityStudents);
  };

  const handleChangePresentModify = (event, studentActivityDateEid) => {
    const checked = event.target.checked;
    const activityStudents = clone(_activityStudents);

    // clone and find
    for (const student of activityStudents) {
      if (student.studentActivityDateEid === studentActivityDateEid) {
        student.is_present = checked;
        evalStudentStatus(student);
        break;
      }
    }
    setActivityStudents(activityStudents);
    updateCounts(activityStudents);
  };

  const handleChangeLateModify = (event, studentActivityDateEid) => {
    const checked = event.target.checked;
    const activityStudents = clone(_activityStudents);

    // clone and find
    for (const student of activityStudents) {
      if (student.studentActivityDateEid === studentActivityDateEid) {
        student.is_late = checked;
        evalStudentStatus(student);
        break;
      }
    }
    setActivityStudents(activityStudents);
    updateCounts(activityStudents);
  };

  const updateCounts = (activityStudents) => {
    let presentCount = 0;
    let lateCount = 0;
    let absentCount = 0;

    for (const student of activityStudents) {
      if (student.is_late) {
        lateCount++;
      }

      if (student.is_present) {
        presentCount++;
      } else {
        absentCount++;
      }
    }

    setPresentCount(presentCount);
    setLateCount(lateCount);
    setAbsentCount(absentCount);
  };

  const handlePointsClose = () => {
    setDialogPointsOpen(false);
  };

  const handlePointsOK = () => {
    if (_selectedScoreCategory === "0") {
      showError("Unable to Assign Points", "Please select a category.");
      return;
    }
    setDialogPointsOpen(false);

    // get selected student eids
    const studentEids = [];

    // attach a few extra attributes for each student
    for (let student of _activityStudents) {
      if (student.pointChecked === true) {
        studentEids.push(student.user_eid);
      }
    }

    setShowProgress(true);
    saveADPoints(
      _school,
      _jwt,
      activityDateEid,
      studentEids,
      _selectedScoreCategory,
      _selectedScoreValue,
    )
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to Save Points: ", getError(results));
          return;
        }

        showToast("S", "Points Saved");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleChangeScoreCategory = (event) =>
    setSelectedScoreCategory(event.target.value);
  const handleChangeScoreValue = (event) =>
    setSelectedScoreValue(event.target.value);

  const evalStudentStatus = (student) => {
    let status = "";

    if (student.is_late) {
      status = "late";
    } else {
      if (student.is_present) {
        status = "present";
      } else {
        status = "absent";
      }
    }

    const mapQueue = clone(_mapQueue);
    mapQueue[student.user_eid] = status;
    console.log(mapQueue);
    setMapQueue(mapQueue);
  };

  const updateDeltaAttendance = () => {
    setDeltaAttendanceCount(_deltaAttendanceCount + 1);

    // unlike regular attendance, these are just deltas
    const presentEids = [];
    const absentEids = [];
    const lateEids = [];

    Object.keys(_mapQueue).forEach(function (userEid) {
      console.log(`SAVING ${userEid} ${_mapQueue[userEid]}`);
      // skip skunkers
      if (userEid.length <= 1) {
        return;
      }
      if (_mapQueue[userEid] === "present") {
        presentEids.push(userEid);
      } else if (_mapQueue[userEid] === "absent") {
        absentEids.push(userEid);
      } else if (_mapQueue[userEid] === "late") {
        lateEids.push(userEid);
      }
    });

    setShowProgress(true);
    updateAttendance(
      _school,
      _jwt,
      activityDateEid,
      presentEids,
      lateEids,
      absentEids,
      _lateToTardy,
    )
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to Update Attendance: ", getError(results));
          return;
        }

        setMapQueue({});
        showToast("S", "Attendance Updated");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleClickSave = () => {
    updateDeltaAttendance();
  };

  const handleClickDetails = (event, student) => {
    setSelectedAttendee(student);
    setDialogDetailsOpen(true);
  };

  const handleDetailsClose = () => {
    setDialogDetailsOpen(false);
  };

  const handleClickSignupQr = () => {
    navigate(`/teacher/ad/signup/${activityDateEid}`);
  };

  const handleClickAttendanceQr = () => {
    navigate(`/teacher/ad/attend/${activityDateEid}`);
  };

  const onTabChange = (event, index) => setSelectedTabIndex(index);

  const handleStudentResultClose = () => {
    setDialogStudenResultOpen(false);
  };

  const doUpdateSelectedItem = (student, hourNum, minuteNum) => {
    const activityStudents = clone(_activityStudents);
    let found = false;

    for (const activityStudent of activityStudents) {
      if (activityStudent.user_eid === student.user_eid) {
        found = true;
        activityStudent.hourNum = hourNum;
        activityStudent.minuteNum = minuteNum;
        break;
      }
    }

    if (found === true) {
      setActivityStudents(activityStudents);
    }
  };

  const onSaveServiceOps = () => {
    // loop the students and save in bulk
    const values = [];

    if (_commServiceType === "XX") {
      return;
    }

    if (_commServiceDescription === "") {
      return;
    }

    for (const activityStudent of _activityStudents) {
      if (activityStudent.hourNum > 0 || activityStudent.minuteNum > 0) {
        console.log(activityStudent);
        values.push({
          studentEid: activityStudent.user_eid,
          hourNum: activityStudent.hourNum,
          minuteNum: activityStudent.minuteNum,
        });
      }
    }

    if (values.length === 0) {
      return;
    }

    teacherAddCommService(
      _school,
      _jwt,
      _commServiceType,
      activityDateEid,
      _commServiceDescription,
      values,
    ).then((results) => {
      initExistingOps();
      alert("Op(s) Added.");
    });
  };

  const initExistingOps = () => {
    getActivityDateCommServices(_school, _jwt, activityDateEid).then(
      (results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get Service Ops: ", getError(results));
          return;
        }

        setExistingOps(results.data.ops);
      },
    );
  };

  const onClickRemoveOp = (op) => {
    deleteCommService(_school, _jwt, op.eid).then((result) => {
      showToast("S", "Service Deleted.");
      initExistingOps();
    });
  };

  const gotoFutureDates = () => {
    getFutureActivityDates(_school, _jwt, activityDateEid).then((results) => {
      if (hasError(results) === true) {
        showToast("E", "Unable to get Future Activities: ", getError(results));
        return;
      }

      for (const item of results.data) {
        item.isSelected = true;
      }

      setFutureActivityDates(results.data);
    });
    setDialogFutureDatesOpen(true);
  };

  const handleFutureDatesClose = () => {
    setDialogFutureDatesOpen(false);
  };

  const handleFutureDatesOK = () => {
    // setDialogFutureDatesOpen(false);
    const studentEids = [];
    const adEids = [];

    for (let student of _activityStudents) {
      if (student.isFutureChecked) {
        studentEids.push(student.user_eid);
      }
    }

    for (let ad of _futureActivityDates) {
      if (ad.isSelected) {
        adEids.push(ad.eid);
      }
    }

    if (studentEids.length === 0) {
      alert("Please select 1 or more students.");
      return;
    }

    if (adEids.length === 0) {
      alert("Please select 1 or more dates.");
      return;
    }

    // save the multitude
    doService(
      bulkAdd(_school, _jwt, studentEids, adEids, "N", "N"),
      (results) => {
        setShowProgress(false);

        setAddSuccesses(results.data.successes);
        setAddFails(results.data.fails);
        setDialogStudenResultOpen(true);
        setDialogFutureDatesOpen(false);
      },
    );
  };

  const handleChangeFutureStudentChecked = (event, item) => {
    const activityStudents = clone(_activityStudents);

    for (let student of activityStudents) {
      if (item.eid === student.eid) {
        student.isFutureChecked = event.target.checked;
        break;
      }
    }

    setActivityStudents(activityStudents);
  };

  const handleChangeFutureDateChecked = (event, item) => {
    const futureActivityDate = clone(_futureActivityDates);

    for (let ad of futureActivityDate) {
      if (ad.eid === item.eid) {
        ad.isSelected = event.target.checked;
        break;
      }
    }

    setFutureActivityDates(futureActivityDate);
  };

  const handleClickSignupAttendanceQr = () => {
    navigate(`/teacher/ad/signup-attend/${activityDateEid}`);
  };

  const handleClickKiosk = () => {
    navigate(`/teacher/ad/${activityDateEid}/attendance/kiosk`);
  };

  const onClickPresent = () => {
    const studentIdTrimmed = _studentId.trim();
    if (studentIdTrimmed === "") {
      return;
    }

    const activityStudents = clone(_activityStudents);
    let found = false;
    let studentObj = null;

    for (let student of activityStudents) {
      if (student.externalId === studentIdTrimmed) {
        found = true;
        student.is_present = true;
        student.is_late = false;
        evalStudentStatus(student);
        studentObj = student;
        break;
      }
    }

    if (found === false) {
      showError(
        "Student Not Found",
        `Student ID ${studentIdTrimmed} not found in this activity.`,
      );
    } else {
      setActivityStudents(activityStudents);
      showToast(
        "S",
        `Student ${studentObj.first_name} ${studentObj.last_name} marked present. Click Save to update attendance records.`,
      );
      updateCounts(activityStudents);
    }

    setStudentId("");
  };

  const onCloseMessage = () => {
    setOpenMessage(false);
  };

  const onClickSendMessage = () => {
    if (isEmpty(_messageText)) {
      alert("Please enter a message to send.");
      return;
    }

    setOpenMessage(false);

    setShowProgress(true);
    sendActivityDateMessage(_school, _jwt, activityDateEid, _messageText)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to Send Message: ", getError(results));
          return;
        }
        showToast("S", "Message Sent");
        setShowProgress(false);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleDialogClose = () => {
    setDialogSelectActivityOpen(false);
  };

  const handleDialogSaveComplete = () => {
    showToast(
      "S",
      `Activities Saved for ${dayjs(_activityDetails.date).format("MM/DD")}.`,
    );
    setDialogSelectActivityOpen(false);
    return initActivityDateStudents();
  };

  return (
    <>
      <DrawerAppBar />
      <SearchBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Take Attendance" showBack={true} />
        <ProgressBar showProgress={_showProgress} />

        <BrowserView>
          <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
            <span className="emphasis">INSTRUCTIONS</span> - Mark the Students
            who are in attendance, and click one of the SAVE buttons below.
            {_school.scoreEnabled === "Y" && (
              <>
                <br />
                <span className="emphasis">TARDY NOTE:</span> Check the "Assign
                Late to Tardy" checkbox below to automatically create a Tardy
                entry.
              </>
            )}
          </Alert>

          {_activityDetails.attendanceTaken === 0 &&
            _deltaAttendanceCount === 0 && (
              <Alert severity="warning" sx={{ mt: 1, mb: 1 }}>
                Attendance NOT marked as taken for this activity. Please click
                SAVE.
              </Alert>
            )}
        </BrowserView>
        {_activityDetails.attendanceModify === "Y" && (
          <Tabs value={_selectedTabIndex} onChange={onTabChange}>
            <Tab
              label="Details"
              sx={{
                borderRight: "1px solid #ccc",
                minHeight: 48,
              }}
            />
            <Tab
              label="QRs"
              sx={{
                borderRight: "1px solid #ccc",
                minHeight: 48,
              }}
            />
            <Tab
              label="Scan"
              sx={{
                borderRight: "1px solid #ccc",
                minHeight: 48,
              }}
            />
          </Tabs>
        )}

        {_activityDetails.attendanceModify === "N" && (
          <Tabs value={_selectedTabIndex} onChange={onTabChange}>
            <Tab label="Details" />
          </Tabs>
        )}

        {_selectedTabIndex === 0 && (
          <Box sx={{ p: 1, mt: 0, border: "1px solid #e8e8e8" }}>
            {_isLoaded === false && (
              <>
                <Skeleton />
                <Skeleton />
              </>
            )}
            {_isLoaded === true && (
              <ActivityDetails
                school={_school}
                activityDetails={_activityDetails}
              />
            )}
          </Box>
        )}

        {_activityDetails.attendanceModify === "Y" && (
          <>
            {_selectedTabIndex === 1 && (
              <Box sx={{ p: 1, border: "1px solid #e8e8e8" }}>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={4}>
                    <Button
                      onClick={handleClickSignupQr}
                      variant="contained"
                      fullWidth
                    >
                      Sign up QR
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <Button
                      onClick={handleClickAttendanceQr}
                      variant="contained"
                      fullWidth
                      className="button1"
                    >
                      Attendance QR
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <Button
                      onClick={handleClickSignupAttendanceQr}
                      variant="contained"
                      fullWidth
                      className="button2"
                    >
                      Signup+Attend QR
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </>
        )}

        {_selectedTabIndex === 2 && (
          <Box sx={{ p: 1, border: "1px solid #e8e8e8" }}>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4}>
                <InputLabel sx={{ mt: 1 }}>* Student ID</InputLabel>
                <Box display="flex" gap={1}>
                  <TextField
                    margin="dense"
                    type="text"
                    fullWidth
                    size="small"
                    onChange={(evt) => setStudentId(evt.target.value)}
                    value={_studentId}
                    sx={{ mt: 0 }}
                  />
                  <Button variant="contained" onClick={onClickPresent}>
                    Submit
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">
            <Grid container>
              <Grid item xs={6}>
                Student Roster ({_activityStudents.length})
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "right", color: "#565c65" }}>
                Present: {_presentCount}
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "right", color: "#565c65" }}>
                Late: {_lateCount}
              </Grid>
              <Grid item xs={2} sx={{ textAlign: "right", color: "#565c65" }}>
                Absent: {_absentCount}
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item sx={6}>
                <Button
                  key="save1"
                  onClick={handleClickSave}
                  sx={{ ml: 0, mt: 0 }}
                  color="success"
                  variant="contained"
                >
                  SAVE
                </Button>
                <Button
                  variant="contained"
                  sx={{ ml: 2, mt: 0 }}
                  onClick={handleClickKiosk}
                >
                  Attendance Kiosk
                </Button>
              </Grid>
              <Grid item sx={6}>
                <Button
                  variant="contained"
                  sx={{ mb: 1, mr: 2 }}
                  onClick={gotoAddStudent}
                >
                  Add Student
                </Button>
                <Menu
                  menuButton={
                    <Button variant="outlined" sx={{ mb: 1 }}>
                      Actions
                    </Button>
                  }
                  transition
                >
                  {_activityDetails.attendanceModify === "Y" && (
                    <>
                      <ReactMenuItem
                        value="AS"
                        onClick={(event) => handleChangeListAction(event)}
                      >
                        Add Student(s)
                      </ReactMenuItem>
                      <ReactMenuItem
                        value="ASS"
                        onClick={(event) => handleChangeListAction(event)}
                      >
                        Add Student List
                      </ReactMenuItem>
                    </>
                  )}
                  <ReactMenuItem
                    value="CS"
                    onClick={(event) => handleChangeListAction(event)}
                  >
                    Create Student List
                  </ReactMenuItem>
                  <ReactMenuItem
                    value="FD"
                    onClick={(event) => handleChangeListAction(event)}
                  >
                    Assign Attendees to Future Dates
                  </ReactMenuItem>
                  <ReactMenuItem
                    value="SM"
                    onClick={(event) => handleChangeListAction(event)}
                  >
                    Send Message
                  </ReactMenuItem>

                  {_school.communityServiceEnabled === "Y" && (
                    <ReactMenuItem
                      value="CSER"
                      onClick={(event) => handleChangeListAction(event)}
                    >
                      Community Service
                    </ReactMenuItem>
                  )}
                </Menu>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={6} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(event) => handleChangeAllPresentModify(event)}
                    />
                  }
                  label="All Present"
                />
              </Grid>
              {_school.scoreEnabled === "Y" && (
                <>
                  <Grid item xs={6} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(event) =>
                            handleChangeAllPointsModify(event)
                          }
                        />
                      }
                      label="All Points"
                    />
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(event) => handleChangeLateToTardy(event)}
                        />
                      }
                      label="Assign Late to Tardy"
                    />
                  </Grid>
                </>
              )}
            </Grid>

            <BrowserView>
              <TableContainer component={Paper} sx={{ mt: 0 }}>
                <Table sx={{ width: "100%" }} size="small">
                  <TableHead>
                    <StripedTableRow>
                      <StripedTableCell align="center">
                        Present?
                      </StripedTableCell>
                      <StripedTableCell align="center">Late?</StripedTableCell>
                      <StripedTableCell>Student Name</StripedTableCell>
                      <StripedTableCell>Comments</StripedTableCell>
                      {/* {_school.scoreEnabled === "Y" && (
                        <StripedTableCell align="center">
                          Points?
                        </StripedTableCell>
                      )} */}
                      <StripedTableCell align="center">
                        Options
                      </StripedTableCell>
                    </StripedTableRow>
                  </TableHead>
                  <TableBody>
                    <TableRowNoResults data={_activityStudents} />
                    {_activityStudents.map((student, i) => (
                      <StripedTableRow key={i}>
                        <StripedTableCell align="center">
                          <Checkbox
                            sx={{ pt: 0 }}
                            checked={student.is_present}
                            className="chkPresent"
                            onChange={(event) =>
                              handleChangePresentModify(
                                event,
                                student.studentActivityDateEid,
                              )
                            }
                          />
                        </StripedTableCell>
                        <StripedTableCell align="center">
                          <Checkbox
                            sx={{ pt: 0 }}
                            checked={student.is_late}
                            className="chkLate"
                            onChange={(event) =>
                              handleChangeLateModify(
                                event,
                                student.studentActivityDateEid,
                              )
                            }
                          />
                        </StripedTableCell>
                        <StripedTableCell>
                          <div className="emphasis">
                            {student.last_name}, {student.first_name}
                            {isEmpty(student.mi) === false && (
                              <> {student.mi}.</>
                            )}{" "}
                            ({student.grade})
                          </div>
                          {student.email}
                        </StripedTableCell>
                        <StripedTableCell>
                          {getComments(student)}
                          {student.is_school_absent === true && (
                            <Alert severity="warning" sx={{ mt: 1, mb: 1 }}>
                              Is Absent from School
                            </Alert>
                          )}
                        </StripedTableCell>

                        <StripedTableCell align="center">
                          {_activityDetails.attendanceModify === "Y" &&
                            ((_schoolStatus &&
                              _schoolStatus.teacherEditEnabled === "Y") ||
                              getUserPriority(_jwt) === 800) && (
                              <>
                                {_school.enableTransfer === "Y" && (
                                  <Tooltip title="Transfer Student to Another Activity">
                                    <IconButton
                                      key={`btnTransfer${student.studentActivityDateEid}`}
                                      onClick={(event) =>
                                        handleClickStudentTransfer(
                                          event,
                                          student,
                                        )
                                      }
                                      sx={{ ml: 1, mt: 0, pt: 0 }}
                                      variant="outlined"
                                      title="transfer"
                                    >
                                      <SendIcon color="primary" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </>
                            )}

                          <Tooltip title="Add Teacher Comment">
                            <IconButton
                              key={`btnComment${student.studentActivityDateEid}`}
                              onClick={(event) =>
                                handleClickTeacherComment(event, student)
                              }
                              sx={{ ml: 0, mt: 0, pt: 0 }}
                              variant="outlined"
                              title="add comment"
                            >
                              <EditIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                        </StripedTableCell>
                      </StripedTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </BrowserView>

            <MobileView>
              <TableContainer component={Paper} sx={{ mt: 0 }}>
                <Table sx={{ width: "100%" }} size="small">
                  <TableHead>
                    <StripedTableRow>
                      <StripedTableCell align="center">
                        Present?
                      </StripedTableCell>
                      <StripedTableCell align="center">Late?</StripedTableCell>
                      <StripedTableCell>Student</StripedTableCell>
                      <StripedTableCell align="center">
                        Details
                      </StripedTableCell>
                    </StripedTableRow>
                  </TableHead>
                  <TableBody>
                    <TableRowNoResults data={_activityStudents} />
                    {_activityStudents.map((student) => (
                      <StripedTableRow>
                        <StripedTableCell align="center">
                          <Checkbox
                            sx={{ pt: 0, pl: 1 }}
                            checked={student.is_present}
                            className="chkPresent"
                            onChange={(event) =>
                              handleChangePresentModify(
                                event,
                                student.studentActivityDateEid,
                              )
                            }
                          />
                        </StripedTableCell>
                        <StripedTableCell align="center">
                          <Checkbox
                            sx={{ pt: 0, pl: 1 }}
                            checked={student.is_late}
                            className="chkLate"
                            onChange={(event) =>
                              handleChangeLateModify(
                                event,
                                student.studentActivityDateEid,
                              )
                            }
                          />
                        </StripedTableCell>
                        <StripedTableCell>
                          {student.last_name}, {student.first_name}
                        </StripedTableCell>
                        <StripedTableCell align="center">
                          <IconButton
                            variant="contained"
                            color="primary"
                            onClick={(event) =>
                              handleClickDetails(event, student)
                            }
                          >
                            <MoreHorizIcon />
                          </IconButton>
                        </StripedTableCell>
                      </StripedTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </MobileView>

            <Button
              key="save2"
              onClick={handleClickSave}
              sx={{ ml: 0, mt: 2 }}
              color="success"
              variant="contained"
            >
              SAVE
            </Button>
          </AccordionDetails>
        </Accordion>
      </Container>

      <SelectStudentsDialog
        open={_dialogStudentsOpen}
        onClose={handleStudentsClose}
        onOK={handleStudentsOK}
        students={_students}
        selectSingle={_school.eid === "9241fe59-40fe-4ac6-aa89-49eaae988b3d" ? true : false}
      />

      <SelectStudentListsDialog
        open={_dialogStudentListsOpen}
        onClose={handleStudentListClose}
        onOK={handleStudentListOK}
        studentLists={_userListOptions}
      />

      {/* <SelectActivityListsDialog
        title="Transfer Student to Another Activity"
        open={_dialogActivityOpen}
        onClose={handleActivityListClose}
        onOK={handleActivityListOK}
        activities={_availableActivities}
        showCreatePass={isPassEnabled(_school)}
      /> */}

      <Dialog
        PaperProps={{
          sx: {
            maxWidth: 450,
            maxHeight: 400,
          },
        }}
        onClose={handlePointsClose}
        open={_dialogPointsOpen}
        fullScreen={true}
        aria-labelledby="select-student-list-dialog-title"
        aria-describedby="select-student-list-dialog-description"
      >
        <DialogTitle id="select-student-list-dialog-title">
          Apply Points to Selected Students
        </DialogTitle>

        <DialogContent>
          <InputLabel sx={{ mt: 1 }}>Select Score Category: *</InputLabel>
          <Select
            id="scoreCategory"
            onChange={handleChangeScoreCategory}
            value={_selectedScoreCategory}
            sx={{ mb: 2 }}
          >
            <MenuItem key="0" value="0">
              -- SELECT CATEGORY --
            </MenuItem>

            {_scoreCategories.map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>

          <InputLabel sx={{ mt: 1 }}>Select Score Value: *</InputLabel>
          <Select
            id="scoreValue"
            onChange={handleChangeScoreValue}
            value={_selectedScoreValue}
            sx={{ mb: 2 }}
          >
            <MenuItem key="0" value="0">
              0
            </MenuItem>
            <MenuItem key="1" value="1">
              1
            </MenuItem>
            <MenuItem key="2" value="2">
              2
            </MenuItem>
            <MenuItem key="3" value="3">
              3
            </MenuItem>
            <MenuItem key="4" value="4">
              4
            </MenuItem>
            <MenuItem key="5" value="5">
              5
            </MenuItem>
          </Select>
        </DialogContent>

        <DialogActions>
          <Button onClick={handlePointsClose}>Cancel</Button>
          <Button variant="contained" onClick={handlePointsOK}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <AttendeeDetailsDialog
        open={_dialogDetailsOpen}
        onClose={handleDetailsClose}
        attendee={_selectedAttendee}
      />

      <AddStudentResultDialog
        open={_dialogStudentResultOpen}
        successes={_addSuccesses}
        fails={_addFails}
        onClose={handleStudentResultClose}
      />

      {_school.communityServiceEnabled === "Y" && (
        <CommServiceBulkDialog
          school={_school}
          jwt={_jwt}
          dialogOpen={_commServiceDialogOpen}
          setDialogOpen={setCommServiceDialogOpen}
          activityDateEid={activityDateEid}
          students={_activityStudents}
          onSave={onSaveServiceOps}
          doUpdateSelectedItem={doUpdateSelectedItem}
          commServiceType={_commServiceType}
          setCommServiceType={setCommServiceType}
          commServiceDescription={_commServiceDescription}
          setCommServiceDescription={setCommServiceDescription}
          existingOps={_existingOps}
          onClickRemove={onClickRemoveOp}
        />
      )}

      <Dialog
        PaperProps={{
          sx: {
            maxWidth: 750,
          },
        }}
        onClose={handleFutureDatesClose}
        open={_dialogFutureDatesOpen}
      >
        <DialogTitle id="select-student-list-dialog-title">
          Select Students to Add to Future Dates
        </DialogTitle>

        <DialogContent>
          <Alert severity="info" sx={{ mb: 1 }}>
            Select the students and the dates to add them to for this type of
            activity.
          </Alert>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
                <AccordionSummary className="accordionTitle">
                  Select Student(s)
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper} sx={{ mt: 0 }}>
                    <Table size="small">
                      <TableBody>
                        {_activityStudents.map((student) => (
                          <StripedTableRow key={student.user_eid}>
                            <StripedTableCell>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    sx={{ pt: 0, pb: 0 }}
                                    checked={student.isFutureChecked}
                                    className="chkPresent"
                                    onChange={(event) =>
                                      handleChangeFutureStudentChecked(
                                        event,
                                        student,
                                      )
                                    }
                                  />
                                }
                                label={`${student.last_name}, ${student.first_name}`}
                              />
                            </StripedTableCell>
                          </StripedTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={6}>
              <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
                <AccordionSummary className="accordionTitle">
                  Select Date(s)
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper} sx={{ mt: 0 }}>
                    <Table sx={{ width: "100%" }} size="small">
                      <TableBody>
                        {_futureActivityDates.map((ad) => (
                          <StripedTableRow>
                            <StripedTableCell>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    sx={{ pt: 0, pb: 0 }}
                                    checked={ad.isSelected}
                                    className="chkPresent"
                                    onChange={(event) =>
                                      handleChangeFutureDateChecked(event, ad)
                                    }
                                  />
                                }
                                label={
                                  dayjs(ad.date).format("MM/DD") +
                                  " " +
                                  getPeriodName(_school, ad.period - 1)
                                }
                              />
                            </StripedTableCell>
                          </StripedTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleFutureDatesClose} variant="outlined">
            Cancel
          </Button>
          <Button variant="contained" onClick={handleFutureDatesOK}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={_openMessage}
        onClose={onCloseMessage}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Send Message</DialogTitle>

        <DialogContent>
          <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
            Enter the message below to send an email to the students who are
            currently assigned to this activity.
            <br />
            NOTE: This may result in many emails being sent out. Please use with
            caution.
          </Alert>

          <InputLabel sx={{ mt: 1 }}>* Message to Send</InputLabel>
          <TextField
            type="text"
            fullWidth
            multiline
            rows={4}
            onChange={(evt) => setMessageText(evt.target.value)}
            placeholder="Required Field"
            value={_messageText}
            sx={{ mt: 1 }}
          />
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={onCloseMessage}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onClickSendMessage}>
            SEND EMAIL
          </Button>
        </DialogActions>
      </Dialog>

      <StudentActivitySignupDialog
        open={_dialogSelectActivityOpen}
        dialogDate={_dialogDate}
        school={_school}
        jwt={_jwt}
        studentEid={_selectedStudent != null ? _selectedStudent.user_eid : null}
        userSettings={_userSettings}
        onClose={handleDialogClose}
        onSaveComplete={handleDialogSaveComplete}
      />
    </>
  );
};

export default TakeAttendance;
